import { b2x } from '@b2x/react/src';

import { ComponentWrapper } from './ComponentWrapper';
import { AssetAContentType } from './contentTypes';

export const AssetA = ({ asset, options }: AssetAContentType) => {
  return (
    <ComponentWrapper classNames="asset-a" options={options}>
      <b2x.AssetV2 {...asset} />
    </ComponentWrapper>
  );
};
